const _excluded = ["children", "overrideClassName", "target"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
function InternalLink(_ref, ref) {
  let {
      children,
      overrideClassName,
      target
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const rel = props.rel === undefined && target === "_blank" ? "noreferrer" : props.rel;
  return /*#__PURE__*/React.createElement("a", _extends({
    className: cx("text-link-primary hover:text-active-link-primary visited:text-active-link-primary", "no-underline hover:underline", target === "_blank" && "after:content-['_↗'] rtl:after:content-['']", overrideClassName),
    target: target,
    rel: rel,
    ref: ref
  }, props), children);
}
export const Link = /*#__PURE__*/React.forwardRef(InternalLink);